  <div class="cme-card-container position-relative "
    [appAnalyticsEvent]="analyticsData" [ngClass]="{'pt-2 mb-2  container-shadow': screenName.GRAND_ROUND !== callingfrom}">
    <div class="position-absolute w-100 h-100 masking-div"
      *ngIf="cmeObj?.channel?.content_visibility?.display==0 || cmeObj?.channel?.content_visibility?.display==2 || cmeObj?.hl?.mcnt">
      <app-product-masking-card 
        [content_visibility]="cmeObj?.channel.content_visibility"  [communityVisible]="cmeObj?.hl?.mcnt">
      </app-product-masking-card>
    </div>
    <div (click)="fcs.stopEventPropagation(); navigateTodetail(cmeObj?.course_id)">
      <div class="px-3 pt-3 pb-2">
        <div class="row">
          <div class="col-md-8 col-7 pr-0 cursor-pointer" [ngClass]="[screenName.GRAND_ROUND, screenName.BOOKMARK_LIST].indexOf(callingfrom) < numbers.ZERO ? 'pl-4': 'pl-3'">
            <p class="clearfix">
              <span *ngIf="cmeObj?.total_points?.score > 0
                  && cmeObj?.total_points?.is_cme_under_progress == 0
                  && cmeObj.cme_type !== Cme_Type.QUIZ"
                  [id]="'CME_CARD_VALUE-'+cmeObj?.total_points.score"
                class="chip small outline icon-position-left score mr-2 mb-3">
                <img src="assets/images/grandround/cme_points.svg" width="15px" />
                <span
                  *ngIf="cmeObj?.total_points?.score > 0">{{cmeObj?.total_points?.score}}</span>
                  &nbsp;{{cmeObj?.total_points?.point_label}}</span>
              <span *ngIf="cmeObj?.total_points?.is_cme_under_progress == 1
                  && cmeObj.cme_type !== Cme_Type.QUIZ"
                class="chip small outline in-progress mr-2 mb-2">
                {{cmeObj?.total_points?.is_cme_under_progress_label}}</span>
    
              <span class="chip small timeline mr-2 mb-3">
                <span class="color-grey-700">
                {{mls.languageText.cme_card.key4}}<span *ngIf="mls?.is_lskey_display==1"> (cme_card.key4)</span>
                <span class="time"> {{cmeObj?.expiry_date | date}}</span></span>
              </span>
            </p>
                <p class="heading-4 mb-2">{{ (cmeObj?.course_name.length>40)? (cmeObj?.course_name | slice:0:40)+'...':(cmeObj?.course_name) }}
                </p>
    
            <p class="secondary-paragraph ellipsis">
              <span class="color-grey-500 mr-2"
                (click)="fcs.stopEventPropagation(); getSpecialty(Sl)"
                *ngFor="let Sl of cmeObj?.speciality;">
                <span *ngIf="cmeObj?.speciality !=''">#</span>{{Sl?.speciality_name}}
              </span>
            </p>
    
            <p class="mt-2 mb-1 accrd" [ngClass]="{'d-none':[screenName.GRAND_ROUND, screenName.BOOKMARK_LIST].indexOf(callingfrom) > numbers.MINUS_ONE}">
              <span class="channel-img position-relative">
                <img loading="lazy" class="mr-2 post-pic rounded-circle"
                  [src]="cmeObj?.accreditated?.accreditation_url | fitInImg :igs.imageGroup.fitin_50x50 "
                  onerror="this.src='assets/themes/icons/sponsor-placeholder.svg'" />
                  <span class="secondary-paragraph">
                    <span class="color-grey-500">{{cmeObj?.accreditated?.prefix_label}}</span>
                  </span>
                  <span class="secondary-paragraph-bold ml-1"> <span class="color-grey-700">{{cmeObj?.accreditated?.accreditation}}</span>
                  </span>
              </span>
            </p>
          </div>
          <div class="col-md-4 col-5 cursor-pointer" [ngClass]="[screenName.GRAND_ROUND, screenName.BOOKMARK_LIST].indexOf(callingfrom) < numbers.ZERO ? 'pr-4': 'pr-3'">
            <div class="position-relative text-right">
              <img loading="lazy" class="rounded cme-card-img post-pic mb-2"
                src="{{cmeObj?.banner_url | fitInImg :igs.imageGroup.fitin_500x500 }}"
                onerror="this.src='assets/themes/icons/large-placeholder-search.svg'" />
            </div>
          </div>
        </div>
        <div class="row" [ngClass]="{'align-items-center mt-3': [screenName.GRAND_ROUND, screenName.BOOKMARK_LIST].indexOf(callingfrom) > numbers.MINUS_ONE}">
          <div class="col-md-6 col-lg-8 col-6 col-sm-9 cursor-pointer d-flex " [ngClass]="[screenName.GRAND_ROUND, screenName.BOOKMARK_LIST].indexOf(callingfrom) < numbers.ZERO ? 'align-items-end pl-4': 'flex-column pl-3 pr-0'">
            <p class="accrd" [ngClass]="[screenName.GRAND_ROUND, screenName.BOOKMARK_LIST].indexOf(callingfrom) > numbers.MINUS_ONE ? 'd-block': 'd-none'">
              <span class="channel-img position-relative">
                <img loading="lazy" class="mr-2 post-pic rounded-circle"
                  [src]="cmeObj?.accreditated?.accreditation_url | fitInImg :igs.imageGroup.fitin_50x50 "
                  onerror="this.src='assets/themes/icons/sponsor-placeholder.svg'" />
                  <span class="secondary-paragraph">
                    <span class="color-grey-500">{{cmeObj?.accreditated?.prefix_label}}</span>
                  </span>
                  <span class="secondary-paragraph-bold ml-1"> <span class="color-grey-700">{{cmeObj?.accreditated?.accreditation}}</span>
                  </span>
              </span>
            </p>
            <div class="row my-2 pl-3">
              <p *ngIf="cmeObj?.module_count != '' && cmeObj?.module_count != null && cmeObj.cme_type == Cme_Type.MODULE" class="mt-1">
                <span class="badge badge-pill badge-primary p-2">{{cmeObj?.module_count}}</span>
              </p>
              <p class="mt-1 w-100">
                <span class="secondary-paragraph" *ngIf="cmeObj?.remark != 'failed'"><span class="color-grey-500 responive-font">{{cmeObj?.number_of_user }}</span>
                </span>
                <span *ngIf="cmeObj?.remark == 'failed'"
                  class="points mr-2 chip small filled success">{{mls?.languageText?.cme_card.key8}}
                  <span *ngIf="mls?.is_lskey_display == 1">(cme_card.key8)</span> </span>
              </p>
            </div>
          </div>
          
          <div *ngIf="cmeObj?.remark != 'passed'" class="col-md-6 col-lg-4 col-6 col-sm-3" [ngClass]="[screenName.GRAND_ROUND, screenName.BOOKMARK_LIST].indexOf(callingfrom) < numbers.ZERO ? 'pr-4': 'pr-3'">
            <button [ngClass]="[(cmeObj?.remark != 'passed' && ((cmeObj.is_reattempt_allow ===1 && cmeObj.attempts.attempted > 0) || (cmeObj.is_reattempt_allow ===0 && cmeObj.attempts.attempted === 0) )) ?(cmeObj?.remark == 'failed' ? 'outline': 'filled passed-btn') : 'outline-disabled re-attempt', (fcs.device_detail.is_desktop!=true) ?'w-75':'']" 
              class="btn-design small float-right"
              [eventTracker]='{"category":callingfrom,"action":(cmeObj?.remark == "not_attempted")? mls.googleEventText.cme_card.key3 : mls.googleEventText.cme_card.key5,"product_type":cmeObj.product_type, "product_id":cmeObj.product_type_id}'><span
                *ngIf="cmeObj?.remark == 'not_attempted'">{{mls.languageText.cme_card.key3}}<span
                  *ngIf="mls?.is_lskey_display==1">(cme_card.key3)</span></span>
              <span *ngIf="cmeObj?.remark == 'failed'">{{mls.languageText.cme_card.key5}}<span
                  *ngIf="mls?.is_lskey_display==1">(cme_card.key5)</span></span>
            </button>
          </div>
    
          <div
            *ngIf="cmeObj?.remark === 'passed' && cmeObj.certificate !== 0"
              class="col-md-6 col-lg-4 col-6 text-right">
              <button class="btn-design small filled pt-1 pb-1" (click)="fcs.stopEventPropagation(); viewCertificate()"
                [ngClass]="{'w-75':fcs.device_detail.is_desktop!=true}"
                [eventTracker]='{"category":callingfrom,"action": mls.googleEventText.cme_card.key6,"product_type":cmeObj.product_type, "product_id":cmeObj.product_type_id}'>
                <span>{{mls.languageText.cme_card.key6}}<span *ngIf="mls?.is_lskey_display==1">(cme_card.key6)</span></span>
            </button>
          </div>
    
        </div>
        <ng-container *ngIf="cmeObj.cme_type === Cme_Type.QUIZ && cmeObj.quiz_leaderboard_url !== ''">
          <div class="row mt-4 mx-2 leader-board">
            <div class="col-6 px-0 bg-deep-green-100 pl-3 checking d-flex align-items-center" (click)="fcs.stopEventPropagation(); navigateToLeaderBoard()">
              <span class="primary-small">{{mls.languageText.cme_card.key10}}</span>
            </div>
            <div class="col-6 bg-deep-green-100 pr-0 lederboard-cta d-flex justify-content-end align-items-center" (click)="fcs.stopEventPropagation(); navigateToLeaderBoard()">
              <span class="btn-design link d-flex justify-content-end">
                <span class="mr-2">{{mls.languageText.cme_card.key9}}</span>
                <img src="assets/themes/icons/right-arrow-head.svg" height="12" class="float-right clearfix mt-1 mr-3" alt="share" />
              </span>
            </div>
          </div>
        </ng-container>
      </div>
      <div *ngIf="(this.mls.featureOnOffList.featureList.bookmark.value || this.mls.featureOnOffList.featureList.share.value )|| !mls.userLoginFlow" class="separator-line" [ngClass]="{'mt-0': [screenName.GRAND_ROUND, screenName.BOOKMARK_LIST].indexOf(callingfrom) > numbers.MINUS_ONE}"></div>
      <div *ngIf="(this.mls.featureOnOffList.featureList.bookmark.value || this.mls.featureOnOffList.featureList.share.value )|| !mls.userLoginFlow" class=" px-2 py-3">
        <div class="row">
          <div *ngIf="this.mls.featureOnOffList.featureList.bookmark.value || !mls.userLoginFlow" class="col-6 text-center">
            <p>
              <span (click)="fcs.stopEventPropagation(); productBookmark()" class="cursor-pointer"
                [eventTracker]='{"category":callingfrom,"action": mls.googleEventText.cme_card.key1,"product_type":cmeObj.product_type, "product_id":cmeObj.product_type_id}'>
                <span class="mr-2">
                  <ng-container *ngIf="cme_bookmark_loader==true">
                    <img src="assets/themes/images/primary-loader.gif" width="20" alt="loading icon">
                  </ng-container>
                  
                  <ng-container *ngIf="cmeObj.is_bookmarked!=1 && cme_bookmark_loader==false">
                    <img class="img-position" src="assets/themes/icons/bookmark.svg" alt="bookmark icon">
                  </ng-container>
                  <ng-container *ngIf="cmeObj.is_bookmarked==1 && cme_bookmark_loader==false">
                    <img class="img-position" src="assets/themes/icons/bookmarked.svg" alt="bookmarked icon">
                  </ng-container>
                </span>
                <span class="button" 
                  *ngIf="cmeObj.is_bookmarked!=1">
                  <span class="color-grey-700">{{mls.languageText.cme_card.key1}}
                    <span
                      *ngIf="mls?.is_lskey_display==1">(cme_card.key1)
                    </span>
                  </span>
                </span>
                <span class="button"
                  *ngIf="cmeObj.is_bookmarked==1">
                  <span class="color-grey-700">{{mls.languageText.cme_card.key7}}
                  <span *ngIf="mls?.is_lskey_display==1">(cme_card.key7)</span>
                </span>
                </span>
              </span>
            </p>
          </div>
    
          <div *ngIf="this.mls.featureOnOffList.featureList.share.value || !mls.userLoginFlow" class="col-6 text-center cursor-pointer btn-design link" 
            (click)="fcs.stopEventPropagation(); productShare()"
            [eventTracker]='{"category":callingfrom,"action": mls.googleEventText.cme_card.key2,"product_type":cmeObj.product_type, "product_id":cmeObj.product_type_id}'>
            <p><span class="mr-2">
              <img class="img-position" src="assets/themes/icons/share.svg" alt="share icon" /> </span>
              <span class="color-grey-700">{{mls.languageText.cme_card.key2}}<span *ngIf="mls?.is_lskey_display==1">(cme_card.key2)</span></span>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
    
  <app-product-subscribe 
    [showSubscribeModal]="showSubscribeModal" 
    [channelData]="subscribe_obj"
    (resetSubscribeModal)="resetSubscribeModal()">
  </app-product-subscribe>
    
  <app-media-modal 
    *ngIf="mediaModal==true && openMediaIndex!=undefined" 
    (resetMediaModal)="setResetMediaModal()"
    [isMediaModalShown]="mediaModal" 
    [mediaObj]="mediaObj" 
    [openMediaIndex]="openMediaIndex" 
    [pType]="pType.CME">
  </app-media-modal>